
import { Component, Input, OnDestroy, OnInit, Injector } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { WalletEmailAlertRegisterDialogComponent } from '../wallet-email-alert-register-dialog/wallet-email-alert-register-dialog.component';
import { Subscription, take } from 'rxjs';
import { FormsModule } from '@angular/forms';
import {
  ConfirmationDialogComponent,
  ConfirmDialogResult,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { WalletEmailAlertConfigService } from '../services/wallet-email-alert-config.service';
import { GenericTableComponent } from 'src/app/shared/components/generic-table';
import { TableCellDirective } from 'src/app/shared/components/generic-table/directives/table-cell.directive';
import {
  getWalletEmailsTableConfig,
  WALLET_EMAILS_NO_DATA_MESSAGE,
} from './wallet-emails-table-config';
import { AlertEmail } from 'src/app/services/models/alert-service/alert-email.model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-wallet-emails-tab',
  templateUrl: './wallet-emails-tab.component.html',
  styleUrls: ['./wallet-emails-tab.component.scss'],
  imports: [
    MatSlideToggleModule,
    FormsModule,
    MatDialogModule,
    GenericTableComponent,
    TableCellDirective
],
})
export class WalletEmailsTabComponent implements OnInit, OnDestroy {
  @Input() walletId!: string;
  @Input() isAlert30Days: boolean = false;

  walletEmails: AlertEmail[] = [];
  isEditing = false;
  isSaving = false;
  isLoading = false;

  tableConfig = getWalletEmailsTableConfig();
  noDataMessage: string = WALLET_EMAILS_NO_DATA_MESSAGE;

  subscriptions: Subscription[] = [];

  constructor(
    private readonly walletEmailAlertConfigService: WalletEmailAlertConfigService,
    private readonly dialog: MatDialog,
    private readonly injector: Injector,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.walletEmailAlertConfigService.getWalletEmails$().subscribe((emails) => {
        this.walletEmails = emails;
        this.isLoading = false;
      }),
    );

    this.subscriptions.push(
      this.walletEmailAlertConfigService.getIsLoadingEmailList$().subscribe((isLoading) => {
        this.isLoading = isLoading;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onStatusChange(checked: boolean, walletAlertEmail: AlertEmail) {
    walletAlertEmail.status = checked;
    this.walletEmailAlertConfigService.toggleEmailAlertStatus(walletAlertEmail, checked);
  }

  handleDeleteEmailAlert(email: AlertEmail) {
    const confirmDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: $localize`:@@EmailDeletionTitle:Eliminación de e-mail`,
        message: $localize`:@@ConfirmEmailDeletion:¿Confirmar la eliminación del e-mail?`,
        confirmButton: {
          text: $localize`:@@js_Delete:Eliminar`,
        },
      },
      disableClose: true,
    });

    confirmDialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((value) => {
        if (value === ConfirmDialogResult.Confirm) {
          this.isLoading = true;
          this.deleteEmail(email);
        }
      });
  }

  deleteEmail(value: AlertEmail) {
    this.walletEmailAlertConfigService.deleteEmail(value);
  }

  handleEditEmailAlert(targetEmailAlert: AlertEmail) {
    this.isEditing = true;
    this.openEmailAlertManagerDialog(targetEmailAlert);
  }

  addEmail() {
    this.openEmailAlertManagerDialog();
  }

  openEmailAlertManagerDialog(targetEmailAlert?: AlertEmail) {
    const dialogReference = this.dialog.open(WalletEmailAlertRegisterDialogComponent, {
      data: {
        alertEmail: targetEmailAlert,
        allEmails: this.walletEmails.map((alertEmail) => alertEmail.email),
        walletId: this.walletId,
      },
      injector: this.injector,
    });

    dialogReference
      .afterClosed()
      .pipe(take(1))
      .subscribe((value?: AlertEmail) => {
        this.isEditing = false;
      });
  }
}
